var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"}},_vm._l((_vm.shopids),function(s,index){return _c('webviewnowin',{key:index,ref:'webviewnowin-' + s,refInFor:true})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }